/**
 * 分享邀请
 * @returns
 */

import {
  Box,
  Flex,
  Image,
  Divider,
  Center,
  Button,
  SimpleGrid,
  useBreakpointValue,
  Tabs,
  TabList,
  Tab,
  TabIndicator,
  TabPanels,
  TabPanel,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  useDisclosure,
  HStack,
  Text,
  Input,
  Select,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import ArrowRight from "@/assets/images/arrow_right.png";
import IntegralTaskItem from "@/components/integralComponent/intergralTaskItem";
import { Consume, TradeType, RecordType } from "@/types/integral";
import { Task } from "@/types/task";
import Integral1 from "@/assets/images/integral_img1.png";
import Integral2 from "@/assets/images/integral_img2.png";

import Consume1 from "@/assets/images/integral_img4.png";
import IntegralConsumeItem from "@/components/integralComponent/integralConsumeItem";
import PayCenterModal from "@/components/payCenterModal";
import SimplePage from "@/components/pagination/simplePage";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateUser, selectUser } from "@/reducer/userslice";
import {
  useLazyGetOrdersQuery,
  useLazyGetPayListQuery,
} from "@/services/api/endpoints/integral";
import { useGetTasksQuery } from "@/services/api/endpoints/task";

const MyIntegral = () => {
  const navigate = useNavigate();
  const PayControl = useDisclosure();
  const [tabIndex, setTabIndex] = useState<number>(0);
  const [beginTime, setBeginTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [payWay, setPayWay] = useState("微信");
  const [recordType, setRecordType] = useState("会员");
  const [pageSize, setPageSize] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(0);
  // const [memberOrderRecords, setMemberOrderRecords] = useState<TradeType[]>(0);

  const user = useSelector(selectUser);
  // console.log(user);

  const { data: dailyTasks } = useGetTasksQuery({ task_type: "daily", user_id:user.id });

  const columns1 = useBreakpointValue({
    base: 1,
    sm: 1,
    md: 1,
    lg: 2,
    xl: 3,
  });
  const columns2 = useBreakpointValue({
    base: 2,
    sm: 2,
    md: 3,
    lg: 4,
    xl: 6,
  });

  const handleChangeBeginTime = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log(e.target.value, ">>>>>>>>>>>>>>12345");
    setBeginTime(e.target.value);
  };
  const handleChangeEndTime = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEndTime(e.target.value);
  };
  const handleChangeRecordType = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setRecordType(e.target.value);
    setCurrentPage(0);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const [getMemberOrderRecords, { data: memberOrderRecords }] = useLazyGetOrdersQuery();
  const [getRechargeOrderRecords, { data: rechargeOrderRecords }] = useLazyGetOrdersQuery();
  const [getPayRecords, { data: payRecords }] = useLazyGetPayListQuery();

  useEffect(()=>{
    if(currentTabIndex===0 && recordType === "会员"){
      getMemberOrderRecords({
        page: currentPage,
        per_page: pageSize,
        begin_time: beginTime,
        end_time: endTime,
        type: "0",
      })
    }
    if(currentTabIndex===0 && recordType === "充值"){
      getRechargeOrderRecords({
        page: currentPage,
        per_page: pageSize,
        begin_time: beginTime,
        end_time: endTime,
        type: "1",
      })
    }
    if(currentTabIndex===1){
      getPayRecords({
        page: currentPage,
        per_page: pageSize,
        begin_time: beginTime,
        end_time: endTime
      })
    }
    
  },[currentTabIndex, recordType])
  // const { data: memberOrderRecords } = useGetOrdersQuery({
  //   page: currentPage,
  //   per_page: pageSize,
  //   begin_time: beginTime,
  //   end_time: endTime,
  //   type: "0",
  // });
  // const { data: rechargeOrderRecords } = useGetOrdersQuery({
  //   page: currentPage,
  //   per_page: pageSize,
  //   begin_time: beginTime,
  //   end_time: endTime,
  //   type: "1",
  // });

  // const { data: payRecords } = useGetPayListQuery({
  //   page: currentPage,
  //   per_page: pageSize,
  //   begin_time: beginTime,
  //   end_time: endTime,
  // });

  const handleChangeTab = (index:number) => {
    setCurrentPage(0);
    setCurrentTabIndex(index)
    
  };

  const IntegralConsume: Consume[] = [
    {
      id: "1",
      product_name: "LEOSAM 插画大模型",
      level: 1,
      price: 299,
      img_url: `${Consume1}`,
      username: "安晨茜",
    },
    {
      id: "2",
      product_name: "LEOSAM 插画大模型",
      level: 2,
      price: 299,
      img_url: `${Consume1}`,
      username: "安晨茜",
    },
    {
      id: "3",
      product_name: "LEOSAM 插画大模型",
      level: 0,
      price: 299,
      img_url: `${Consume1}`,
      username: "安晨茜",
    },
    {
      id: "4",
      product_name: "LEOSAM 插画大模型",
      level: 3,
      price: 299,
      img_url: `${Consume1}`,
      username: "安晨茜",
    },
    {
      id: "5",
      product_name: "LEOSAM 插画大模型",
      level: 0,
      price: 299,
      img_url: `${Consume1}`,
      username: "安晨茜",
    },
    {
      id: "6",
      product_name: "LEOSAM 插画大模型",
      level: 0,
      price: 299,
      img_url: `${Consume1}`,
      username: "安晨茜",
    },
  ];

  // 购买积分
  const handlePurchaseIntegral = () => {
    PayControl.onOpen();
    setTabIndex(1);
  };
  //   充值会员
  const handleRechargeMembership = () => {
    PayControl.onOpen();
    setTabIndex(0);
  };

  const handleSearch = () => {};

  return (
    <Box overflow={"hidden"}>
      <Box width="80%" m="0 auto">
        <Box
          mt="40px"
          mb="20px"
          color="#27314D"
          fontWeight="bold"
          fontSize="24px"
        >
          我的积分
        </Box>
        <Box
          h="149px"
          background={"linear-gradient(90deg, #8E94A9 0%, #27314D 100%) "}
        >
          <Flex
            w="100%"
            alignItems="center"
            style={{
              height: "100%",
            }}
          >
            <Flex flex={1} justifyContent="space-around">
              <Box>
                <Box color={"#E6E6E6"} fontSize="14px" mb="10px">
                  总积分账户余额
                </Box>
                <Box
                  color={"#ffffff"}
                  fontSize="48px"
                  fontWeight={"400"}
                  lineHeight={"48px"}
                  fontFamily="Allerta"
                >
                  {user.totalcoin || 0}
                </Box>
              </Box>
              <Box>
                <Box color={"#E6E6E6"} fontSize="14px" mb="10px">
                  永久可用积分
                </Box>
                <Box
                  color={"#ffffff"}
                  fontSize="48px"
                  fontWeight={"400"}
                  lineHeight={"48px"}
                  fontFamily="Allerta"
                >
                  {user.rechargecoin || 0}
                </Box>
              </Box>
              <Box>
                <Box color={"#E6E6E6"} fontSize="14px" mb="10px">
                  赠送积分
                </Box>
                <Box
                  color={"#ffffff"}
                  fontSize="48px"
                  fontWeight={"400"}
                  lineHeight={"48px"}
                  fontFamily="Allerta"
                >
                  {user.givecoin || 0}
                </Box>
              </Box>
            </Flex>
            <Divider h="50px" orientation="vertical" />
            <Box flex={1}>
              <Center gap={"30px"}>
                <Button
                  borderRadius={"40px"}
                  width={"130px"}
                  height={"44px"}
                  color="#27314D"
                  bgColor="#fff"
                  fontWeight={"normal"}
                  border={"1px solid #8E94A9"}
                  fontSize="14px"
                  _hover={{
                    bgColor: "#CBD1DF",
                    border: "1px solid #8E94A9",
                  }}
                  onClick={handlePurchaseIntegral}
                >
                  购买积分
                </Button>
                <Button
                  borderRadius={"40px"}
                  width={"130px"}
                  height={"44px"}
                  color="#FFFFFF"
                  bgColor="#496AE1"
                  fontWeight={"normal"}
                  fontSize="14px"
                  _hover={{
                    bgColor: "#3F5BC1",
                    color: "#E6E6E6",
                  }}
                  onClick={handleRechargeMembership}
                >
                  充值会员
                </Button>
              </Center>
            </Box>
          </Flex>
        </Box>
        <Flex
          justifyContent={"space-between"}
          alignItems="center"
          mt="40px"
          mb="20px"
        >
          <Box color={"#27314D"} fontSize="18px" fontWeight={"bold"}>
            积分任务
          </Box>
          <Button
            color="#27314D"
            fontSize={"12px"}
            fontWeight="normal"
            variant="link"
            onClick={() => {
              navigate("/task");
            }}
          >
            任务中心 <Image src={ArrowRight} />
          </Button>
        </Flex>
        <Box>
          <SimpleGrid columns={columns1} gap={"20px 30px"}>
            {dailyTasks && dailyTasks.map((task, index) => {
              if (index < 6) {
                return (
                  <Box
                    border={"1px solid #DCE0EB"}
                    boxSizing="border-box"
                    key={task.id}
                  >
                    <IntegralTaskItem task={task} isCompleted={false} />
                  </Box>
                );
              }
            })}
          </SimpleGrid>
        </Box>

        <Flex
          justifyContent={"space-between"}
          alignItems="center"
          mt="40px"
          mb="20px"
        >
          <Box color={"#27314D"} fontSize="18px" fontWeight={"bold"}>
            积分消耗
          </Box>
          <Button
            color="#27314D"
            fontSize={"12px"}
            fontWeight="normal"
            variant="link"
          >
            查看全部 <Image src={ArrowRight} />
          </Button>
        </Flex>
        <Box overflow={"hidden"}>
          <SimpleGrid columns={columns2} gap={"30px"}>
            {IntegralConsume.map((consume) => (
              <Box key={consume.id}>
                <IntegralConsumeItem consume={consume} />
              </Box>
            ))}
          </SimpleGrid>
        </Box>
        {/* 表格 */}
        <Box mt="40px">
          <Tabs
            position="relative"
            variant="unstyled"
            onChange={handleChangeTab}
          >
            <TabList borderBottom={"1px solid #E0E0E0"}>
              <Tab
                sx={{
                  fontSize: "18px",
                  color: "#8E94A9",
                }}
                _selected={{
                  color: "#27314D",
                  fontWeight: "bold",
                  borderBottom: "2px solid #27314D",
                }}
              >
                {recordType === "会员" && "会员购买记录"}
                {recordType === "充值" && "充值"}
              </Tab>
              <Tab
                sx={{
                  fontSize: "18px",
                  color: "#8E94A9",
                }}
                _selected={{
                  color: "#27314D",
                  fontWeight: "bold",
                  borderBottom: "2px solid #27314D",
                }}
              >
                积分详情
              </Tab>
            </TabList>
            <Flex mt="20px" flexWrap={"wrap"} justifyContent={"space-between"}>
              <HStack spacing={0} mb="5px">
                <Text fontSize={"12px"} color="#8E94A9">
                  充值时间：
                </Text>
                <Input
                  border="1px solid #DCE0EB"
                  placeholder="请选择"
                  w="110px"
                  fontSize={"12px"}
                  color={"#8E94A9"}
                  size="sm"
                  type="date"
                  value={beginTime}
                  onChange={handleChangeBeginTime}
                />
                <Text color={"#DCE0EB"}>—</Text>
                <Input
                  border="1px solid #DCE0EB"
                  placeholder="请选择"
                  w="110px"
                  fontSize={"12px"}
                  color={"#8E94A9"}
                  size="sm"
                  type="date"
                  value={endTime}
                  onChange={handleChangeEndTime}
                />
                <Button
                  ml="6px"
                  borderRadius={"0"}
                  width={"56px"}
                  height={"29px"}
                  color="#FFFFFF"
                  bgColor="#496AE1"
                  fontWeight={"normal"}
                  fontSize="12px"
                  _hover={{
                    bgColor: "#3F5BC1",
                    color: "#E6E6E6",
                  }}
                  onClick={handleSearch}
                >
                  确定
                </Button>
              </HStack>
              <Flex mb="5px">
                <HStack spacing={0} mr={"10px"}>
                  <Text fontSize={"12px"} color="#8E94A9">
                    支付方式：
                  </Text>
                  <Select
                    color={"#27314D"}
                    fontSize={"12px"}
                    border="none"
                    w="100px"
                    size="xs"
                    // placeholder="请选择"
                    value={payWay}
                    onChange={(e) => setPayWay(e.target.value)}
                  >
                    <option value=" 微信">微信支付</option>
                  </Select>
                </HStack>
                <HStack spacing={0}>
                  <Text fontSize={"12px"} color="#8E94A9">
                    记录类型：
                  </Text>
                  <Select
                    color={"#27314D"}
                    fontSize={"12px"}
                    border="none"
                    w="100px"
                    size="xs"
                    value={recordType}
                    onChange={handleChangeRecordType}
                  >
                    <option value="会员">购买会员</option>
                    <option value="充值">充值记录</option>
                  </Select>
                </HStack>
              </Flex>
            </Flex>
            <TabPanels>
              {/* 会员购买记录 */}
              <TabPanel>
                <Box mb="40px">
                  {recordType === "会员" && (
                    <TableContainer>
                      <Table
                        variant="simple"
                        fontSize="14px"
                        fontWeight={"normal"}
                      >
                        <Thead color={"#333333"}>
                          <Tr>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              会员卡类型
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              订单号
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              有效期
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              会员卡价格
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              优惠折扣
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              实付款
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              购买数量
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              赠送数量
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              支付方式
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              下单时间
                            </Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {memberOrderRecords &&
                            memberOrderRecords.map((row, index) => {
                              const total1 = row.total + row.discount;
                              const total = total1 / 100;
                              const discount = row.discount / 100;
                              const realTotal = row.total / 100;
                              return (
                                <Tr key={index} color="#333333">
                                  <Td textAlign="center">{row.product_name}</Td>
                                  <Td textAlign="center">{row.order_sn}</Td>
                                  <Td textAlign="center">{row.untilday}</Td>
                                  <Td textAlign="center">￥{total}</Td>
                                  <Td textAlign="center">￥{discount}</Td>
                                  <Td textAlign="center">￥{realTotal}</Td>
                                  <Td textAlign="center">{row.count}</Td>
                                  <Td textAlign="center">{row.givecount}</Td>
                                  <Td textAlign="center">{row.payway}</Td>
                                  <Td textAlign="center">{row.update_at}</Td>
                                </Tr>
                              );
                            })}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  )}
                  {recordType === "充值" && (
                    <TableContainer>
                      <Table
                        variant="simple"
                        fontSize="14px"
                        fontWeight={"normal"}
                      >
                        <Thead color={"#333333"}>
                          <Tr>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              订单号
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              商品名称
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              实付款
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              购买数量
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              赠送数量
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              支付方式
                            </Th>
                            <Th
                              fontSize="14px"
                              fontWeight={"normal"}
                              textAlign="center"
                            >
                              支付时间
                            </Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {rechargeOrderRecords &&
                            rechargeOrderRecords.map((row, index) => {
                              const total = row.total / 100;
                              return (
                                <Tr key={index} color="#333333">
                                  <Td textAlign="center">{row.order_sn}</Td>
                                  <Td textAlign="center">{row.product_name}</Td>
                                  <Td textAlign="center">￥{total}</Td>
                                  <Td textAlign="center">{row.count}</Td>
                                  <Td textAlign="center">{row.givecount}</Td>
                                  <Td textAlign="center">{row.payway}</Td>
                                  <Td textAlign="center">{row.update_at}</Td>
                                </Tr>
                              );
                            })}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  )}
                </Box>
                <SimplePage
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </TabPanel>

              {/* 积分记录 */}
              <TabPanel>
                <Box mb="40px">
                  <TableContainer>
                    <Table
                      variant="simple"
                      fontSize="14px"
                      fontWeight={"normal"}
                    >
                      <Thead color={"#333333"}>
                        <Tr>
                          <Th
                            fontSize="14px"
                            fontWeight={"normal"}
                            textAlign="center"
                          >
                            创建时间
                          </Th>
                          <Th
                            fontSize="14px"
                            fontWeight={"normal"}
                            textAlign="center"
                          >
                            类型
                          </Th>
                          <Th
                            fontSize="14px"
                            fontWeight={"normal"}
                            textAlign="center"
                          >
                            积分
                          </Th>
                          <Th
                            fontSize="14px"
                            fontWeight={"normal"}
                            textAlign="center"
                          >
                            详情
                          </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {payRecords &&
                          payRecords.map((row, index) => {
                            return (
                              <Tr key={index} color="#333333">
                                <Td textAlign="center">{row.createat}</Td>
                                <Td textAlign="center">{row.type}</Td>
                                <Td textAlign="center">
                                  {row.ispay ? "- " : "+ "}
                                  {row.amount}
                                </Td>
                                <Td textAlign="center">{row.detail}</Td>
                              </Tr>
                            );
                          })}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Box>
      <PayCenterModal
        tabIndex={tabIndex}
        isOpen={PayControl.isOpen}
        onClose={PayControl.onClose}
      />
    </Box>
  );
};

export default MyIntegral;
